export const data_stahltreppen =
    {
        category: 'Stahltreppe',
        modell: [
            {
                index: '',
                img: '',
                titel: '',
                muster: '',
                price: 1298
            }
        ],
        gelaender: [
            {
                gelaender_type: '',
                gelaender_index: '',
                img: ''
            }
        ],
        data_description: [
            {
                image: '',
                file: '',
                own_modell_file: '',
                own_modell_image: '',
                description: '',
                isUploadData: false
            }
        ],
        steps: [
               [[false], [false], [false], [false], [false], [false]],
                {
                    visited: [0],
                    active_steps: []
                }
        ],
        geschosshoehe: [
            {
                height: '',
                stufen: 0
            }
        ],
        podest: [
            {
                isPodest: false,
                podestWidth: ''
            }
        ],
        stufenBreite: '',
        handlauf: [
            {
                isHandlauf: false,
                handlauf_form: '',
                endkappe: '',
                endkappe_index: ''
            }
        ],
        colors: [
            {
                kind_of_color: '',
                wish_color: '',
                color_index: '',
                color: '',
            }
        ],
        allVisitedSteps: false,
        isEdit: false,
        is_merkliste: false
    }


